import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  featuredProducts: [],
  recommendedProducts: [],
  pickles: [],
  powders: [],
  sweets: [],
  snacks: [],
  selectedProduct: null,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setFeaturedProducts: (state, action) => {
      state.featuredProducts = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setRecommendedProducts: (state, action) => {
      state.recommendedProducts = action.payload;
    },
    setPickles: (state, action) => {
      state.pickles = action.payload;
    },
    setPowders: (state, action) => {
      state.powders = action.payload;
    },
    setSweets: (state, action) => {
      state.sweets = action.payload;
    },
    setSnacks: (state, action) => {
      state.snacks = action.payload;
    },
  },
});

export const {
  setProducts,
  setFeaturedProducts,
  setRecommendedProducts,
  setPickles,
  setPowders,
  setSweets,
  setSnacks,
  setSelectedProduct
} = productsSlice.actions;

export default productsSlice.reducer;